import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FeatureInstanceComponent } from '../feature-instance/feature-instance.component';
import { FlatTabsComponent } from './flat-tabs/flat-tabs.component';
import { TabService } from './flat-tabs/tab.service';
import { TestingService } from '../../testing.service';
import { NgtLinkComponent } from '@corporate/ng-tebis-base-components';
import { AssistantComponent } from "../../07_feature/assistant/assistant.component";
// import { DebugService } from '../../04_service/debug.service';

@Component({
  selector: 'tps-flat-layout',
  imports: [
    FlatTabsComponent,
    FeatureInstanceComponent,
    AssistantComponent,
    NgtLinkComponent,
],
  templateUrl: './flat-layout.component.html',
  styleUrl: './flat-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlatLayoutComponent {

  testing = inject(TestingService);
  tabService = inject(TabService);

  // // use this to test if the backend main stack is accessible and the authorization works
  // debugService = inject(DebugService);
  // constructor() {
  //   this.debugService.getTime();
  //   this.debugService.getContext();
  //   this.debugService.getEvent();
  // }
}
